import React, { Component } from 'react';
import MatchHydrate from '../match-hydrate.js';
import menuesRootview from '../../menues_rootview.js';
import AccountPendingWithdrawals from './account-pending-withdrawals.js';
import AccountSettings from './account-settings.js';
import AccountUpload from './account-upload.js';
import uploadDocuments from './../../upload-documents.js';
import RealityCheckSetTimeLimit from './account-settings-reality-check-set-time-limit.js';
import Deposit from './../deposit.js';
import Withdraw from './../withdraw.js';

class Account extends Component {
	componentWillMount() {
		uploadDocuments.setAccountLinkUploadDocumentsIcon();
		menuesRootview.openAccountMenu();
	}

	componentWillUnmount() {
		menuesRootview.closeMenuesExceptGlobalMenu();
	}

	render() {
		return (
			<div id="account">
				<MatchHydrate authenticate path="/account/pendingwithdrawals" component={AccountPendingWithdrawals} />
				<MatchHydrate authenticate path="/account/mysettings" component={AccountSettings} />
				<MatchHydrate authenticate path="/account/upload/:page?" component={AccountUpload} />
				<MatchHydrate authenticate path="/account/reality-check-set-time-limit" component={RealityCheckSetTimeLimit} />
				<MatchHydrate authenticate path="/account/deposit" component={Deposit} />
				<MatchHydrate authenticate path="/account/withdraw" component={Withdraw} />
			</div>
		);
	}
}

export default Account;



// WEBPACK FOOTER //
// ./mobile-core/src/components/account/account.js